import type { GeoIpUserLocation, AppUserLocation } from '~/stores/index'

export default function <T extends 'geoip' | 'app'>(
  callback: (userLocation: T extends 'geoip' ? GeoIpUserLocation : AppUserLocation) => void,
  requiredType?: T
) {
  const mainStore = useMainStore()

  if (
    mainStore.userLocation &&
    (requiredType == null || mainStore.userLocation.type === requiredType)
  ) {
    callback(mainStore.userLocation as T extends 'geoip' ? GeoIpUserLocation : AppUserLocation)

    return
  }

  const stopWatching = watch(
    () => mainStore.userLocation,
    (userLocation) => {
      if (!userLocation || (requiredType != null && userLocation.type !== requiredType)) return

      stopWatching()

      callback(userLocation as T extends 'geoip' ? GeoIpUserLocation : AppUserLocation)
    }
  )
}
